var map = {
	"./FileUpload.png": 7250,
	"./Refresh.png": 4346,
	"./analyticsMail.png": 2686,
	"./email.png": 3,
	"./employee.png": 7195,
	"./greenUpArrow.png": 5986,
	"./productCatalogue.png": 5627,
	"./redDownArrow.png": 8755,
	"./slack.png": 5339,
	"./teams.png": 7841,
	"./whatsapp.png": 2841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;